import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=520a71eb&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=ts&"
export * from "./NewsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=520a71eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a71eb",
  null
  
)

export default component.exports